<template>
	<div class="animated fadeIn">
		<CommandHeaderV2 :command_service_id="command_service_id" :record_id="record_id" active="about">
			<div class="pt-3 pr-3 pb-0 pl-3">
                <form id="command__form" @submit="save">
                    <tooltip label="command name" placement="right">
                        <input
                            name="command_name"
                            v-model="record.command_name"
                            v-validate="'required'"
                            :placeholder="$t('command name')"
                            :class="{'form-control': true, 'is-invalid': errors.has('command_name')}"
                            type="text"
                        />
                        <span v-show="errors.has('command_name')" class="help is-danger invalid-feedback">
                            {{ $t(errors.first('command_name')) }}
                        </span>
                    </tooltip>
                    <tooltip label="command description" placement="right">
                        <textarea
                            name="command_description"
                            v-model="record.command_description"
                            class="form-control"
                            type="text"
                            :placeholder="$t('command description')"
                        ></textarea>
                    </tooltip>
                    <tooltip label="command_lang" placement="right">
                        <select
                            name="command_lang"
                            v-model="record.command_lang"
                            class="form-control"
                        >
							<option value="ar">Arabic</option>
							<option value="en">English</option>
							<option value="de">German</option>
						</select>
                    </tooltip>
                </form>
				<ButtonSubmit form="command__form" :levels="['id', 'command_id']" />
			</div>
		</CommandHeaderV2>
	</div>
</template>

<script>
import Vue from 'vue'
import SCommandHeader from '../../components/CommandHeader'
import CommandHeaderV2 from '../../components/CommandHeaderV2'

import {cSwitch, ButtonSubmit} from '../../components'
import VeeValidate from 'vee-validate'
import axios from 'axios';
Vue.use(VeeValidate)

export default {
	name: 'commandForm',
	components: {
		cSwitch,
		SCommandHeader,
		CommandHeaderV2,
		ButtonSubmit,
	},
	data() {
		return {
			record_id: 0,
			command_service_id: 0,
			record: {
				command_name: '',
				command_description: '',
				command_lang: 'ar',
			},
		}
	},
	methods: {
		save(e) {
			e.preventDefault()
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.$root.loader = true
					axios
						.post('/command/save/' + this.command_service_id + '/' + this.record_id, this.record)
						.then((response) => {
							this.$root.loader = false
							if (response.data.status) {
								if (!parseInt(this.record_id)) {
									this.$store.commit('add_go_commands', {
										command_id: response.data.id,
										command_name: this.record.command_name,
									})
								}
								this.$store.commit('update_go_commands', [this.record_id, this.record.command_name])

								this.$store.commit('update_breadcrumb_history', {
									mode: 'commands',
									id: this.record_id,
									change_to: this.record.command_name,
								})

								this.$router.push(
									'/services/' + this.command_service_id + '/commands/' + response.data.id
								)
							}
						})
				} else {
					// invalid
					this.$root.loader = false
				}
			})
		},
	},
	mounted() {
		if (parseInt(this.$route.params.service_id) >= 1) {
			this.command_service_id = parseInt(this.$route.params.service_id)
		}

		if (parseInt(this.$route.params.command_id) >= 1) {
			this.$root.loader = true
			this.record_id = parseInt(this.$route.params.command_id)
			axios.get('/command/browse/' + this.record_id).then((response) => {
				this.$root.loader = false
				if (response.data.status) {
					this.record = response.data.data
				}
			})
		} else {
			this.record_id = 0
			this.$root.loader = false
		}
	},
}
</script>
